import { z } from 'zod';
import { createZodFormResolver, getDefaults, Validation } from '@mews/framework';

export enum GroupExistingCustomerFormKeys {
    companionId = 'companionId',
}

export const groupExistingCustomerFormSchema = z.object({
    [GroupExistingCustomerFormKeys.companionId]: Validation.String.Required.default(''),
});

export type GroupExistingCustomerFormValues = z.infer<typeof groupExistingCustomerFormSchema>;

export const defaultValues = getDefaults(groupExistingCustomerFormSchema) as GroupExistingCustomerFormValues;

export const resolver = createZodFormResolver(groupExistingCustomerFormSchema);
